import {keepPreviousData, queryOptions, useQuery} from '@tanstack/react-query'
import * as sdk from '@cypro/server/sdk'

type Input = sdk.GetPatientsActiveSubstanceTotalsData['query']

export function getPatientsActiveSubstanceTotalsOptions(input: Input) {
  return queryOptions({
    queryKey: ['patients-total-active-substances', input],
    queryFn: async () => {
      const {data} = await sdk.getPatientsActiveSubstanceTotals({query: input})
      return data
    },
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  })
}

export function useGetPatientsActiveSubstanceTotals(input: Input) {
  const {data, ...rest} = useQuery({
    ...getPatientsActiveSubstanceTotalsOptions(input),
  })

  return {...rest, data}
}
